import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";

import {
  leftBotLine,
  leftTopLine,
  rightMiddleLine,
  redLineOne,
  redLineTwo,
  redLineThree,
} from "../../../../../assets/landing/lines";

type JoinRuleCardProps = {
  title: string;
  icon: string;
  information: String[];
  linkName: string;
  isBlueLine?: boolean;
  linkUrl: string;
};

const JoinRuleCard: React.FC<JoinRuleCardProps> = ({
  title,
  icon,
  information,
  linkName,
  isBlueLine = false,
  linkUrl,
}) => {
  return (
    <article className="flex flex-col max-lg:gap-[4.5vw] gap-[1.675vw] w-[31.75vw] max-lg:w-[70.7vw] max-lg:items-center relative z-10">
      <div className="custom-shadow relative z-[8] linear-border w-full flex items-center max-lg:gap-[2.14vw] max-lg:rounded-[6.4vw] gap-6 max-lg:pl-[4.28vw] max-lg:p-[2.14vw] max-lg:h-fit bg-[#F3F3F8] p-[1.2vw] rounded-28">
        <div className="size-[12.79vw] lg:size-[3.34vw] custom-shadow flex items-center justify-center rounded-xl">
          <img className="max-lg:size-[6vw]" src={icon} alt={title} />
        </div>
        <h3 className="font-luxora-regular leading-[1.1] text-[2.5vw] max-lg:text-[6.4vw] text-black">
          {title}
        </h3>
        {isBlueLine ? (
          <img
            src={leftTopLine}
            className="absolute -left-[3.2vw]  max-lg:w-[17.4vw] max-lg:top-[6.2vw] max-lg:z-[20] max-lg:-left-[12vw] max-lg:h-[26.73vw] top-[2.4vw] z-[12] w-[4.75vw] h-[7.7vw]"
            alt="decoration line"
          />
        ) : (
          <img
            src={redLineOne}
            className="absolute -right-[3.2vw]  max-lg:w-[17.4vw] max-lg:top-[6.2vw] max-lg:z-[20] max-lg:-right-[10vw] max-lg:h-[26.73vw] top-[2.4vw] z-[12] w-[4.9vw] h-[8vw]"
            alt="decoration line"
          />
        )}
      </div>
      <div className="flex flex-col gap-[2vw] max-lg:gap-[4.5vw]">
        <div className="relative flex flex-col gap-[2vw] max-lg:gap-[4.5vw] ">
          {information.map((desc, index) => (
            <p
              key={index}
              className="w-full h-[5.28vw] max-lg:h-[17.07vw] flex items-center max-lg:px-[6.4vw] py-[1.1vw] px-[1.675vw] max-lg:text-[3.75vw] max-lg:py-[3.2vw] text-[1.25vw] max-lg:rounded-[6.4vw] z-[15] rounded-28 bg-[#F3F3F8] w-full font-normal leading-[1.1] text-black"
            >
              {desc}
            </p>
          ))}
          {isBlueLine ? (
            <>
              <img
                src={rightMiddleLine}
                className="absolute -right-[3.5vw]  top-[2vw]  w-[7vw] h-[8.89vw]  max-lg:h-[29.33vw] max-lg:w-[26.13vw] max-lg:-right-[10vw] max-lg:top-[3vw]"
                alt="decoration line"
              />
              <img
                src={leftBotLine}
                className={clsx(
                  "absolute -left-[3vw] z-[14] top-[9.5vw]  w-[4.14vw] h-[8.29vw] max-lg:h-[27.2vw] max-lg:w-[15.46vw] max-lg:-left-[12vw] max-lg:top-[27vw]",
                  !isBlueLine && "max-lg:top-[30.5vw]"
                )}
                alt="decoration line"
              />
              <img
                src={rightMiddleLine}
                className="absolute -right-[3.5vw]  top-[15.8vw]  w-[7vw] h-[9.5vw]  max-lg:h-[29.33vw] max-lg:w-[26.13vw] max-lg:-right-[10vw] max-lg:top-[47vw]"
                alt="decoration line"
              />
            </>
          ) : (
            <>
              <img
                src={redLineTwo}
                className="absolute -left-[3.9vw]  top-[2vw]  w-[7vw] h-[8.89vw]  max-lg:h-[30vw] max-lg:w-[26.13vw] max-lg:-left-[11vw] max-lg:top-[3.8vw]"
                alt="decoration line"
              />
              <img
                src={redLineThree}
                className={clsx(
                  "absolute -right-[3.2vw] z-[12] top-[9.5vw]  w-[4.14vw] h-[8.29vw] max-lg:h-[26.2vw] max-lg:w-[15.46vw] max-lg:-right-[11vw] max-lg:top-[28vw]",
                  !isBlueLine && "max-lg:top-[30.5vw]"
                )}
                alt="decoration line"
              />
              <img
                src={redLineTwo}
                className="absolute -left-[3.9vw]  top-[16.2vw]  w-[7vw] h-[9.09vw]  max-lg:h-[28.33vw] max-lg:w-[25.13vw] max-lg:-left-[11vw] max-lg:top-[47.8vw]"
                alt="decoration line"
              />
            </>
          )}
        </div>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          className={clsx(
            "join-button flex items-center relative justify-center max-lg:h-[17.1vw] h-[5.3vw] !z-50    text-white font-luxora-regular leading-[1.1] w-full"
          )}
          to={linkUrl}
        >
          <div></div>
          <span className="text-[1.67vw] max-lg:text-[5.35vw]">{linkName}</span>
        </Link>
      </div>
    </article>
  );
};

export default JoinRuleCard;
